export const GET_RECIPIENTS = 'GET_RECIPIENTS';
export const GET_RECIPIENTS_SUCCESS = 'GET_RECIPIENTS_SUCCESS';
export const GET_RECIPIENTS_ERROR = 'GET_RECIPIENTS_ERROR';
export const GET_RECIPIENT = 'GET_RECIPIENT';
export const GET_RECIPIENT_SUCCESS = 'GET_RECIPIENT_SUCCESS';
export const GET_RECIPIENT_ERROR = 'GET_RECIPIENT_ERROR';
export const ADD_RECIPIENT = 'ADD_RECIPIENT';
export const ADD_RECIPIENT_SUCCESS = 'ADD_RECIPIENT_SUCCESS';
export const ADD_RECIPIENT_ERROR = 'ADD_RECIPIENT_ERROR';
export const UPDATE_RECIPIENT = 'UPDATE_RECIPIENT';
export const UPDATE_RECIPIENT_SUCCESS = 'UPDATE_RECIPIENT_SUCCESS';
export const UPDATE_RECIPIENT_ERROR = 'UPDATE_RECIPIENT_ERROR';
export const DELETE_RECIPIENT = 'DELETE_RECIPIENT';
export const DELETE_RECIPIENT_SUCCESS = 'DELETE_RECIPIENT_SUCCESS';
export const DELETE_RECIPIENT_ERROR = 'DELETE_RECIPIENT_ERROR';
export const CLEAR_RECIPIENTS = 'CLEAR_RECIPIENTS';
export const CLEAR_RECIPIENT = 'CLEAR_RECIPIENT';
export const CLEAR_GET_RECIPIENT_ERROR = 'CLEAR_GET_RECIPIENT_ERROR';
export const CLEAR_ADD_RECIPIENT_ERROR = 'CLEAR_ADD_RECIPIENT_ERROR';
export const PARSE_RECIPIENT_DOCUMENT = 'PARSE_RECIPIENT_DOCUMENT';
export const PARSE_RECIPIENT_DOCUMENT_SUCCESS = 'PARSE_RECIPIENT_DOCUMENT_SUCCESS';
export const PARSE_RECIPIENT_DOCUMENT_ERROR = 'PARSE_RECIPIENT_DOCUMENT_ERROR';
export const CLEAR_PARSE_RECIPIENT_DOCUMENT = 'CLEAR_PARSE_RECIPIENT_DOCUMENT';
export const CLEAR_HIGHLIGHTED_RECIPIENT = 'CLEAR_HIGHLIGHTED_RECIPIENT';

export const getRecipients = () => ({
  type: GET_RECIPIENTS,
});

export const getRecipient = (payload) => ({
  type: GET_RECIPIENT,
  payload,
});

export const addRecipient = (payload) => ({
  type: ADD_RECIPIENT,
  payload,
});

export const updateRecipient = (payload) => ({
  type: UPDATE_RECIPIENT,
  payload,
});

export const deleteRecipient = (payload) => ({
  type: DELETE_RECIPIENT,
  payload,
});

export const clearRecipients = () => ({
  type: CLEAR_RECIPIENTS,
});

export const clearRecipient = () => ({
  type: CLEAR_RECIPIENT,
});

export const clearGetRecipientError = () => ({
  type: CLEAR_GET_RECIPIENT_ERROR,
});

export const clearAddRecipientError = () => ({
  type: CLEAR_ADD_RECIPIENT_ERROR,
});

export const parseRecipientDocument = (payload) => ({
  type: PARSE_RECIPIENT_DOCUMENT,
  payload,
});

export const clearParseRecipientDocument = () => ({
  type: CLEAR_PARSE_RECIPIENT_DOCUMENT,
});

export const clearHighlightedRecipient = () => ({
  type: CLEAR_HIGHLIGHTED_RECIPIENT,
});
